import { inject, Injectable } from '@angular/core'
import type { Data } from '@angular/router'
import { NavigationEnd, Router } from '@angular/router'
import { concat, defer, EMPTY, of } from 'rxjs'
import { filter, map } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class TrackingNavigationService {
  private readonly router = inject(Router)

  readonly pageView$ = defer(() => {
    const navigationFinished = this.router.navigated && this.router.currentNavigation() === null

    return concat(
      navigationFinished ? of(this.currentRouteData()) : EMPTY,
      this.router.events.pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        map(() => this.currentRouteData()),
      ),
    )
  }).pipe(filter(data => data.trackPageViews !== false))

  private currentRouteData(): Data {
    let data: Data = {}
    let route = this.router.routerState.root
    while (route.firstChild) {
      route = route.firstChild
      data = { ...data, ...route.snapshot.data }
    }
    return data
  }
}
